import { Injectable } from '@angular/core';
import { environment } from 'projects/evolutics-shared-lib/src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ChatHelpDeskService {
  showOptions: boolean = true;
  isShown: boolean;
  helpLink = environment.helpLink;
  constructor() {}

  reload() {
    this.closeOptions();
    this.show();
  }
  show() {
    this.isShown = true;
  }
  hide() {
    this.isShown = false;
  }
  hideOptions() {
    this.showOptions = false;
  }
  toggle() {
    this.isShown = !this.isShown;
  }

  closeOptions() {
    this.showOptions = false;
  }
  openOptions() {
    this.showOptions = true;
  }
  toggleOptions() {
    this.showOptions = !this.showOptions;
  }
}
